import { ENDPOINTS, MIDDLEWARE } from "./api-endpoints";
import { extractBaseServer, extractDomain } from "../utils";

export default async function getChatServiceCheck(middleware = undefined, body, trackingId) {
  console.log("Request to check chat service:", {
    middleware,
    endpoint: ENDPOINTS.chatServiceCheck,
    trackingId,
    body,
  });

  try {
    const customHeaders = {
      authorization: trackingId,
      "Content-Type": "application/json",
    };

    console.log("Sending POST request with headers:", customHeaders);

    const response = await fetch((middleware || MIDDLEWARE) + ENDPOINTS.chatServiceCheck, {
      method: "POST",
      headers: customHeaders,
      body: JSON.stringify(body),
    });

    console.log("Received response with status:", response.status);

    if (!response.ok) {
      if (response.status === 404) {
        console.warn("Chat service not found (404). Skipping chat feature.");
        return { error: "Service not found", status: 404 };
      }
      console.error(`Error: HTTP error! status: ${response.status}`);
      return { error: `HTTP error! status: ${response.status}` };
    }

    const data = await response.json();
    console.log("Response data:", data);

    return data;
  } catch (error) {
    console.error("Error in getChatServiceCheck:", error.message);
    return { error: "Network error or unexpected response", details: error.message };
  }
}
